import { Card } from 'antd';
import { FC, ReactElement, memo } from 'react';

import { useAppPagination } from '../../../../../common/hooks';
import { FallbackedLayout } from '../../../../../common/layouts';
import { useGetAllPagesListByPagesQuery } from '../../../queries';
import { PagesListView } from './PagesListView';

interface Props {
  siteId: string;
}

export const PagesListContainer: FC<Props> = memo(({ siteId }) => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const {
    data: pagesListData,
    error: pagesListError,
    isLoading: isPagesListLoading,
    isError: isPagesListError
  } = useGetAllPagesListByPagesQuery(siteId, { page: currentPage })({
    enabled: !!siteId
  });

  return (
    <Card>
      <FallbackedLayout
        data={ pagesListData }
        isLoading={ isPagesListLoading }
        error={ pagesListError }
        isError={ isPagesListError }
      >
        { ({ items, meta }): ReactElement => (
          <PagesListView
            currentPage={ currentPage }
            pagesListItems={ items }
            pagesListTotalItems={ meta.totalItems }
            pagesListItemsPerPage={ meta.itemsPerPage }
            isLoading={ isPagesListLoading }
            handleChangePage={ handleChangePage }
          />
        ) }
      </FallbackedLayout>
    </Card>
  );
});
